module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_iter-step.js
// module id = 291
// module chunks = 16